import { combineReducers } from 'redux';

import { IApplicationState, TReduxActions } from '../types/redux';
import { userReducer } from './user';
import { experimentsReducer } from './experiments';
import { layoutTypeReducer } from './layoutType';
import { duplicateOfferLinkReducer } from './duplicateOfferLink';
import { topicReducer } from './topic';
import { modalReducer } from './modal';
import { referenceLinkReducer } from './referenceLink';
import { partnerRewardsSourceReducer } from './partnerRewardsSource';
import { footerLayoutReducer } from './footerLayout';

export const reducers = combineReducers<IApplicationState, TReduxActions>({
  layoutType: layoutTypeReducer,
  footerLayout: footerLayoutReducer,
  user: userReducer,
  experiments: experimentsReducer,
  duplicateOfferLink: duplicateOfferLinkReducer,
  topic: topicReducer,
  modal: modalReducer,
  referenceLink: referenceLinkReducer,
  partnerRewardsSource: partnerRewardsSourceReducer,
});
